<template>
  <div class="space-y-6 py-1 text-center md:py-6">
    <div v-if="riskAlert && status == 'STOPPED'" class="space-y-6">
      <p class="text-ontick-red-500 text-sm font-bold">
        Atenção, identificamos que no parâmetro escolhido não existe limite de
        perda definido. Caso não esteja certo desta ação, verifique novamente
        seus parâmetros.
      </p>
      <div class="flex items-center space-x-4">
        <input
          type="checkbox"
          id="confirmation"
          class="border-ontick-blue-600 text-ontick-blue-600 ring-ontick-red-600 h-4 w-4 appearance-none rounded border-2 bg-transparent dark:border-gray-300"
          v-model="riskAccepted"
        />
        <label
          for="confirmation"
          class="text-ontick-carbon-900 text-sm font-bold dark:text-gray-300"
        >
          Confirmo que estou usando uma estratégia sem limite de perda
        </label>
      </div>
    </div>
    <ontick-button
      v-if="status == 'STOPPED'"
      @click.native="$emit('confirmCode')"
      :disabled="
        parameterId == null ||
        loadingApi ||
        statusStrategy ||
        (riskAlert && !riskAccepted)
      "
      :bold="true"
      class="w-4/6 uppercase"
    >
      <span
        v-html="
          loadingApi || statusStrategy ? $icons.loading : 'Iniciar estratégia'
        "
      ></span>
    </ontick-button>
    <!-- /end Start -->

    <!-- Stop - Demo -->
    <ontick-button
      v-if="
        ['DEMO', 'CONTEST'].includes(selectedAccount.account_type) &&
        status == 'RUNNING'
      "
      @click.native="$emit('confirmCode')"
      :class="[
        loadingApi
          ? 'bg-ontick-steel-800 hover:bg-ontick-steel-600 cursor-not-allowed'
          : 'bg-ontick-red-700 hover:bg-ontick-red-600',
      ]"
      :color="!loadingApi ? 'red' : 'primary'"
      :disabled="loadingApi"
      :bold="true"
      class="w-4/6 uppercase"
    >
      <span v-html="loadingApi ? $icons.loading : 'PARAR ESTRATÉGIA'"></span>
    </ontick-button>
    <!-- /end Demo -->

    <!-- Stop - Production -->
    <ontick-button
      v-if="selectedAccount.account_type == 'PRD' && status == 'RUNNING'"
      @click.native="$emit('stop')"
      :class="[
        buttonDisabled
          ? 'bg-ontick-steel-800 hover:bg-ontick-steel-600 cursor-not-allowed'
          : '',
      ]"
      :color="!loadingApi ? 'red' : 'primary'"
      :disabled="loadingApi"
      :bold="true"
      class="w-4/6 uppercase"
    >
      <span v-html="loadingApi ? $icons.loading : 'Confirmar'"></span>
    </ontick-button>
    <!-- /end Production -->
  </div>
</template>

<script>
export default {
  props: {
    selectedAccount: { type: Object },
    loadingApi: { type: Boolean },
    status: { type: String },
    buttonDisabled: { type: Boolean },
    parameterId: { type: Number },
    statusStrategy: { type: Boolean },
    noLimitConfirmation: { type: Boolean },
    // riskAlert: { type: Boolean },
    selectedParameter: { type: Object },
  },

  data() {
    return {
      riskAccepted: false,
    };
  },

  computed: {
    riskAlert() {
      return (
        this.selectedParameter.param_data &&
        this.selectedParameter.param_data.risk_alert
      );
    },
  },
};
</script>

<style></style>
